
export default {
  name: 'KorzinkaIcon'
}
